<template>
  <dv-scroll-board :config="config" style="width:100%;height:100%;" />
</template>

<script>
//专区排行
export default {
  name: "ZList1",
  data() {
    return {
      config: {},
    }
  },
  methods:{

  },
  created() {
 


  let data=[];
  data[0]=['江南人家',50009,10002];
  data[1]=['奇味鹅',49837,9967];
  data[2]=['陈记饺味鲜',45968,9193];
  data[3]=['信阳人家滋补鹅三宝',39896,7979];
  data[4]=['烩面私房菜',34984,6996];
  data[5]=['罗涛胡辣汤',33975,6795];
  data[6]=['老路大灶台',50009,7979];
  data[7]=['李老三驴汤',49837,9193];
  data[8]=['好味熟食店',45968,9967];
  data[9]=['福建小吃',39896,10002];
  data[10]=['谭记快餐店',45968,9193];
  data[11]=['武汉红油热干面',50009,9967];




      this.config = {
        header: ['门店名称', '交易金额', '让利金额'],
        rowNum:[6],
        data: data,
        headerBGC: '#0081EE',
        oddRowBGC: '#0e0e26',
        evenRowBGC: '#0e0e26',
        index: true,
        columnWidth: [50,320,],
        align: ['center']
      }
   


  },

  watch: {

  }
}
</script>

<style scoped>

</style>